module.exports = __webpack_public_path__ + "dc63d9db.svg";